<template>
  <FilterBoard
    class="accounts-filter-panel oms-list-filter"
    title="Accounts queue"
    eyebrow=""
  >
      <v-flex xs3 class="accounts-filter-field oms-filter-board__field">
        <v-autocomplete
          v-model="searchTypes"
          :items="searchItems"
          label="Search Type"
          item-text="status"
          single-line
          item-value="abbr"
          @change="searchByType()"
          return-object
        ></v-autocomplete>
      </v-flex>
      <v-divider class="divider-style" vertical></v-divider>
      <v-flex
        xs3
        pr-5
        class="accounts-filter-field oms-filter-board__field oms-filter-board__field--search"
      >
        <v-text-field
          class="gap searchAccounts"
          :disabled="!searchTypes"
          :label="'Search'"
          single-line
          v-model="search"
          append-icon="search"
          @keyup.enter="searchAnything"
          @click:append="searchAnything"
        ></v-text-field>
      </v-flex>
      <v-flex xs5 pt-3 pr-5 class="accounts-filter-field oms-filter-board__field oms-filter-board__field--wide">
        <v-autocomplete
          class="pt-0 currencyTitle"
          :items="customers"
          v-model="customerId"
          label="Select Company Name"
          single-line
          autocomplete="offfadsf"
          @change="searchCustomer"
        />
      </v-flex>
      <v-flex
        xs3
        pl-3
        class="wrapper accounts-filter-date oms-filter-board__field oms-filter-board__field--date"
        id="accountDate"
      >
        <ejs-daterangepicker
          :placeholder="waterMark"
          v-model="dateRange2"
        ></ejs-daterangepicker>
      </v-flex>
      <v-flex xs2 class="accounts-filter-actions oms-filter-board__actions">
        <v-card-actions class="justify-center">
          <v-btn
            class="reset-btn-color accounts-reset-link oms-filter-board__reset"
            flat
            prepend-icon
            color="orange darken-1"
            @click.native="reset()"
          >
            Reset
            <v-icon color="orange">donut_large</v-icon>
          </v-btn>
        </v-card-actions>
      </v-flex>
      <v-flex xs3 class="accounts-filter-invoice oms-filter-board__field oms-filter-board__field--wide">
        <InvoicePopup
          :jobIds="this.$props.jobIds"
          :jobRows="this.$props.jobRows"
          :selectedCustomerForInvoice="this.$props.selectedCustForInvoice"
          :countInvoice="count"
          @customerInvoiceFailed="customerInvoiceFailed()"
          @reset="reset()"
        />
      </v-flex>
  </FilterBoard>
</template>

<script>
import FilterBoard from "@/components/Common/FilterBoard";
import InvoicePopup from "./InvoicePopup";
import { StorageKeys } from "../../constants/constants";
import Vue from "vue";
import { DateRangePickerPlugin } from "@syncfusion/ej2-vue-calendars";

Vue.use(DateRangePickerPlugin);
import moment from "moment";
import Loading from "vue-loading-overlay";
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { EventBus } from "../../event-bus.js";
export default {
  data() {
    return {
      searchItems: [
        {
          status: "Job Id",
          abbr: "jobId",
        },
        { status: "Assignment Id", abbr: "assignmentId" },
        { status: "Sales Invoice Number", abbr: "salesInvoice" },
        { status: "Purchase Invoice Number", abbr: "purchaseInvoice" },
      ],
      searchTypes: "",
      customerId: null,
      waterMark: "Select a Range",
      customers: [],
      customerCurrency: null,
      workingCountry: [],
      startDate: "",
      search: "",
      dateRange: { startDate: "", endDate: "" },
      dateRange2: null,
    };
  },
  components: {
    FilterBoard,
    Loading,
    DateRangePicker,
    InvoicePopup,
  },
  props: {
    jobIds: Array,
    jobRows: Array,
    count: Number,
    selectedCustForInvoice: Object,
  },
  watch: {
    dateRange2() {
      localStorage.setItem("accountStartdate", this.dateRange2.startDate);
      localStorage.setItem("accountlEndDate", this.dateRange2.endDate);
      this.$emit("daterangenew-cust", this.dateRange2);
    },
  },
  created() {
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = workingCountry;
      this.fetchShippers(this.workingCountry);
    }

    EventBus.$on("countryChanged", (val) => {
      this.workingCountry = val;
      this.fetchShippers(this.workingCountry);
      this.reset();
    });
  },
  methods: {
    fetchShippers(val) {
      this.customers = [];
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.t = config.headers.authorization;
      let body = { workingCountry: val, blockCustomerAllow: true };
      this.axios
        .post(`${this.constants.apiUrl}/dmsAdmin/shippers`, body, config)
        .then((response) => {
          const { data = null } = response.data;
          for (var i = 0; i < data.length; i++) {
            data[i].fullName = data[i].companyName;
          }

          data.forEach((element) => {
            if (element.companyName) {
              this.customers.push({
                text: element.fullName,
                value: element.userId,
                companyName: element.companyName,
                companyVatNumber: element.companyVatNumber,
                address: element.address
                  ? element.address.replaceAll("\n", ", ")
                  : "",
                invoicingCity: element.invoicingCity,
                invoicingCountry: element.invoicingCountry,
                selectedIndustry: element.selectedIndustry,
              });
            } else {
              this.customers.push({
                text: element.name,
                value: element.userId,
                companyName: element.companyName,
                companyVatNumber: element.companyVatNumber,
                address: element.address
                  ? element.address.replaceAll("\n", ", ")
                  : "",
                invoicingCity: element.invoicingCity,
                invoicingCountry: element.invoicingCountry,
                selectedIndustry: element.selectedIndustry,
              });
            }
          });
        });
    },
    searchByType() {
      this.search = "";
      this.$emit("filters-type", this.searchTypes.abbr);
      this.$emit("customer-search", this.search);
    },
    searchAnything() {
      localStorage.setItem("searchAccount", this.search);
      localStorage.setItem(
        "searchAccountType",
        JSON.stringify(this.searchTypes)
      );

      this.$emit("customer-search", this.search);
      this.$emit("filter-type", this.searchTypes.abbr);
    },
    customerInvoiceFailed() {
      this.$emit("customerInvoiceFailed", { ...this.selectedCustForInvoice });
    },
    reset() {
      localStorage.removeItem("searchAccount");
      localStorage.removeItem("searchAccountType");
      localStorage.removeItem("accountSearchCust");
      localStorage.removeItem("accountStartdate");
      localStorage.removeItem("accountlEndDate");
      this.$emit("customer-reset", this.search);
      this.search = "";
      this.searchTypes = "";
      this.dateRange2 = null;
      this.customerId = null;
    },
    searchCustomer() {
      localStorage.setItem("accountSearchCust", this.customerId);
      this.$emit("customer-Id", this.customerId);
    },
  },
};
</script>
<style scss>
div#ej2-datetimepicker_0_popup {
  left: auto !important;
  max-width: calc(100vw - 2rem);
  right: 1rem !important;
}
#accountDate .e-input-group-icon.e-range-icon.e-icons::after {
  content: none !important;
}

#accountDate span.e-input-group-icon.e-range-icon.e-icons {
  left: auto;
  margin-left: auto;
  position: static;
  right: auto !important;
  text-align: center;
  width: 1.5rem;
}
#accountDate .e-input-group-icon.e-range-icon::before,
*.e-control-wrapper .e-input-group-icon.e-range-icon::before {
  content: "\e245";
  font-family: "e-icons";
  float: none;
  position: static;
  right: auto;
}
#accountDate .e-daterangepicker {
  left: auto !important;
  max-width: calc(100vw - 2rem);
  right: 1rem;
}
.e-daterangepicker.e-popup .e-calendar,
.e-bigger.e-small .e-daterangepicker.e-popup .e-calendar {
  background-color: #fff;
  height: 100%;
}
#accountDate .e-clear-icon {
  display: none !important;
  opacity: 0;
}
.searchAccounts .v-label.v-label--is-disabled.theme--light {
  left: 0.625rem !important;
}

.searchAccounts .theme--light.v-label {
  left: 0.625rem !important;
}
.searchAccounts input {
  padding-left: 0.625rem !important;
}

.accounts-filter-panel {
  background: var(--oms-surface-soft, #faf9f6);
  border: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: 0.875rem;
  margin: 0 1.5rem;
  max-width: none;
  padding: 0.75rem 0.875rem !important;
}

.accounts-filter-grid {
  align-items: stretch;
  display: grid !important;
  gap: 0.625rem;
  grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
  margin: 0 !important;
  padding: 0 !important;
}

.accounts-filter-grid > .flex {
  align-items: stretch;
  display: flex !important;
  flex-basis: auto !important;
  max-width: none !important;
  min-height: 2.5rem;
  min-width: 0;
  padding: 0 !important;
  width: 100%;
}

.accounts-filter-panel .divider-style {
  display: none;
}

.accounts-filter-actions .v-card__actions {
  align-items: stretch;
  padding: 0;
  width: 100%;
}

.accounts-filter-panel .v-input,
.accounts-filter-panel .wrapper,
.accounts-filter-panel #accountDate {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
}

.accounts-filter-panel .gap {
  margin: 0 !important;
}

.accounts-filter-panel .v-input__control,
.accounts-filter-panel .v-input__slot,
.accounts-filter-panel .v-select__slot,
.accounts-filter-panel .v-text-field__slot {
  min-height: 2.5rem !important;
  width: 100%;
}

.accounts-filter-panel .v-input__slot,
.accounts-filter-panel .e-input-group {
  align-items: center !important;
  background: #ffffff !important;
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  box-sizing: border-box;
  height: 2.5rem !important;
  margin: 0 !important;
  padding: 0 0.75rem !important;
}

.accounts-filter-panel .e-input-group {
  padding: 0.375rem 0.625rem !important;
}

.accounts-filter-panel .v-text-field__details {
  display: none;
}

.accounts-filter-panel .v-label,
.accounts-filter-panel .v-select__selection,
.accounts-filter-panel input {
  color: var(--oms-ink, #3a382f) !important;
  font-size: 0.875rem;
  font-weight: 500;
}

.accounts-filter-panel .v-icon {
  color: var(--oms-muted, #74716a);
  font-size: 1.125rem;
}

.accounts-reset-link {
  background: #ffffff !important;
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  color: var(--oms-primary-dark, #d96a10) !important;
  font-size: 0.8125rem !important;
  font-weight: 800 !important;
  height: 2.5rem !important;
  letter-spacing: 0 !important;
  margin: 0 !important;
  min-width: 5.75rem !important;
  padding: 0 0.75rem !important;
  text-transform: none !important;
  width: 100%;
}

.accounts-reset-link .v-icon {
  color: var(--oms-primary-dark, #d96a10) !important;
  font-size: 1rem !important;
  margin-left: 0.3125rem;
}

.accounts-filter-invoice {
  align-items: center;
}

@media (max-width: 78.75rem) {
  .accounts-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 47.5rem) {
  .accounts-filter-panel {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .accounts-filter-grid {
    grid-template-columns: 1fr;
  }
}
</style>

<style scoped>
.divider-style {
  margin-bottom: 1.5rem;
  margin-top: 0.9375rem;
  background: lightgrey;
}
</style>
